export const menuItems = [
    {
        id: 1,
        label: "Compte",
        isTitle: true
    },
    {
        id: 2,
        label: "Tableau de bord",
        icon: "bx-home-circle",
        link: "/"
    },
    {
        id: 7,
        label: "Menu",
        isTitle: true,
    },
    {
        id: 9,
        label: "Utilisateurs",
        icon: "bx-user",
        link: "/users"
    },
     {
        id: 10,
        label: "Transfers",
        icon: "bx-transfer",
        link: "/transfers",
    },
    {
        id: 10,
        label: "Payments",
        icon: "bx-credit-card",
        link: "/payments",
    },

    {
        id: 10,
        label: "Payouts",
        icon: "bx-wallet",
        link: "/payouts",
    },

    {
        id: 10,
        label: "Trans",
        icon: "bx-git-compare",
        link: "/transfers-users",
    },
   
    {
        id: 10,
        label: "Aggregateurs",
        link: "#",
        icon: "bx-layer",
        subItems: [{
            id: 13,
            label: "Aggregateurs",
            icon: "bx-layer",
            link: "/aggregators",
            parentId: 10
        },{
            id: 10,
            label: "Méthodes",
            icon: "bx-cog",
            link: "/aggregators-methods",
            parentId: 10

        },
        {
            id: 10,
            label: "Transactions",
            icon: "bx-transfer-alt",
            link: "/aggregators-transactions",
            parentId: 10

        },
        {
            id: 10,
            label: "Sommaires",
            icon: "bx-bar-chart-alt-2",
            link: "/aggregators-summaries",
            parentId: 10
        },
        ]
    },
    
     {
        id: 11,
        label: "Définition",
        link: "#",
         icon: "bx-file",
         subItems: [
             {
                id: 10,
                label: "Conversions",
                icon: "bx-refresh",
                link: "/conversions",
             },
             {
                id: 10,
                label: "Echanges",
                icon: "bx-sync",
                link: "/exchanges",
            },
            {
                id: 10,
                label: "Méthodes",
                icon: "bx-cog",
                link: "/moyens",
            },
             {
                id: 13,
                 label: "Devises",
                 icon: "bx-dollar-circle",
                link: "/currencies",
                parentId: 12
            },
             {
                id: 13,
                 label: "Pays",
                 icon: "bx-globe",
                link: "/countries",
                parentId: 12
            },
        ]
    },
    
    
    {
        id: 11,
        label: "managers",
        link: "#",
        icon: "bx-user-pin",
        subItems: [
           {
        id: 10,  
        label: "Managers",
        icon: "bx-user-check",
        link: "/managers",
        parentId: 12

    },
    {
        id: 10,  
        label: "Agents",
        icon: "bx-user-voice",
        link: "/agents",
        parentId: 12

    },
    {
        id: 10,  
        label: "Accounts",
        icon: "bx-id-card",
        link: "/agents-accounts",
        parentId: 12
    },{
        id: 10,
        label: "Wallets",
        icon: "bx-wallet", // Ajouté
        link: "/wallets",
        parentId: 12
            },
        ]
    },


    {
        id: 11,
        label: "Divers",
        link: "#",
        icon: "bx-dots-horizontal-rounded",
        subItems: [{
            id: 13,
            label: "Constantes",
            icon: "bx-slider", // Ajouté
            link: "/constantes",
            parentId: 12
        },{
            id: 13,
            label: "Fichiers",
            icon: "bx-file", // ✅ conservé
            link: "/files",
            parentId: 12
        },
    ]
    },
   
];




// export const menuItems = [{
//         id: 1,
//         label: "menuitems.menu.text",
//         isTitle: true
//     },
//     {
//         id: 2,
//         label: "menuitems.dashboards.text",
//         icon: "bx-home-circle",
//         badge: {
//             variant: "info",
//             text: "menuitems.dashboards.badge"
//         },
//         subItems: [{
//                 id: 3,
//                 label: "menuitems.dashboards.list.default",
//                 link: "/",
//                 parentId: 2
//             },
//             {
//                 id: 4,
//                 label: "menuitems.dashboards.list.saas",
//                 link: "#",
//                 parentId: 2
//             },
//             {
//                 id: 5,
//                 label: "menuitems.dashboards.list.crypto",
//                 link: "#",
//                 parentId: 2
//             },
//             {
//                 id: 6,
//                 label: "menuitems.dashboards.list.blog",
//                 link: "#",
//                 parentId: 2
//             }
//         ]
//     },
//     {
//         id: 7,
//         isLayout: true
//     },
//     {
//         id: 8,
//         label: "menuitems.apps.text",
//         isTitle: true
//     },
//     {
//         id: 9,
//         label: "menuitems.calendar.text",
//         icon: "bx-calendar",
//         link: "#"
//     },
//     {
//         id: 10,
//         label: "menuitems.chat.text",
//         icon: "bx-chat",
//         link: "#",
//     },
//     {
//         id: 11,
//         label: "menuitems.filemanager.text",
//         link: "#",
//         icon: "bx-file",
//         badge: {
//             variant: "success",
//             text: "menuitems.chat.badge"
//         }
//     },
//     {
//         id: 12,
//         label: "menuitems.ecommerce.text",
//         icon: "bx-store",
//         subItems: [{
//             id: 13,
//             label: "menuitems.ecommerce.list.products",
//             link: "#",
//             parentId: 12
//         }, ]
//     },
// ];